<template>
    <a-card>
        <a-input-search v-if="showFilter" v-model="unitFilter" />
        <a-tree
            :treeData="unitTree"
            @select="onUnitSelected"
            defaultExpandAll
            v-if="units.length > 0"
        />
        <a-icon v-if="units.length == 0" type="loading" />
    </a-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

// import units from '../units'
import { createTree } from '@/helpers'

export default {
    props: {
        orgId: {
            required: true,
        },
        currentUnit: {
            type: String,
        },
        showFilter: {
            type: Boolean,
            default: true,
        },
    },

    components: {},
    created() {},

    data() {
        return {
            unitFilter: '',
        }
    },

    computed: {
        defaultOpenKeys() {
            return (
                this.units
                    //.filter(unit => unit.depth < 3)
                    .map(unit => unit.id)
            )
        },

        ...mapGetters({
            // unitTree: 'companies/unitTree',
            units: 'companies/units',
            unitRoot: 'companies/rootUnit',
        }),

        filteredUnits() {
            return this.units
                .filter(unit => {
                    return (
                        unit.name
                            .toLowerCase()
                            .indexOf(this.unitFilter.toLowerCase()) > -1 ||
                        unit.depth == 0
                    )
                })
                .reduce((acc, cur) => {
                    cur.lineage.split('/').forEach(u => {
                        acc.push(u)
                    })
                    return acc
                }, [])
        },

        unitTree() {
            let units = this.units.filter(
                unit => this.filteredUnits.indexOf(unit.id) > -1
            )

            units = JSON.parse(JSON.stringify(units))

            return createTree(units, null)
        },
    },
    methods: {
        onUnitSelected(key) {
            this.$emit('unitSelected', key[0])
        },

        ...mapActions({
            getUnits: 'companies/getUnits',
        }),

        ...mapMutations({}),
    },
    watch: {},
}
</script>
